<template>
  <yd-dialog append-to-body ref="merchantPrice" width="50%" :visible.sync="visible">
    <div slot="title">{{ title }}</div>
    <div>
      <el-table
        :data="fixedPrice"
        :span-method="objectSpanMethod"
        border
        style="width: 50%; margin: 40px 0 50px"
        v-if="type == 1"
      >
        <el-table-column :show-overflow-tooltip="true" label="行程" align="center" width="260">
          <template slot-scope="scope">
            <span>{{ scope.row.startStationName }} - {{ scope.row.endStationName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sellingPrice" label="销售价(元)" align="center" />
        <el-table-column prop="marketPrice" label="市场价(元)" align="center" />
      </el-table>
      <div style="display: flex" v-if="type == 2">
        <div class="lineType" style="width: 25%">
          <el-table
            @cell-click="changeLine"
            :data="seateList"
            :row-class-name="tableRowClassName"
            border
            style="width: 100%; margin: 40px 0 50px"
          >
            <el-table-column label="行程" prop="name" align="center" />
          </el-table>
        </div>
        <div style="width: 40%">
          <el-table
            :data="priceList"
            :span-method="objectSpanMethod"
            border
            style="width: 100%; margin: 40px 0 50px"
          >
            <el-table-column prop="seatNumber" label="座位号" align="center" />
            <el-table-column prop="sellingPrice" label="销售价(元)" align="center" />
            <el-table-column prop="marketPrice" label="市场价格(元)" align="center" />
          </el-table>
        </div>
      </div>
    </div>
  </yd-dialog>
</template>

<script>
  import { priceDetail } from '@/api/transport/boundmerchant'
  export default {
    data() {
      return {
        visible: '',
        title: '',
        type: 0,
        lineType: 0,
        fixedPrice: [],
        seateList: [],
        priceList: [],
        list: []
      }
    },
    created() {},
    mounted() {},
    methods: {
      edit(row) {
        this.visible = true
        this.title = '预览价格方案'
        this.getpriceOrder(row.id)
      },
      tableRowClassName({ rowIndex }) {
        // eslint-disable-next-line eqeqeq
        if (rowIndex == this.lineType) {
          return 'warning-row'
        }
        return ''
      },
      changeLine(row) {
        this.lineType = row.id - 1
        // this.tableRowClassName()
        this.priceList = this.list[this.lineType].priceMethodTypeVOList
      },

      getpriceOrder(id) {
        priceDetail(id).then((res) => {
          // 1 统一价
          if (res.data.ticketType === 1) {
            this.type = 1
            this.fixedPrice = res.data.priceMethodTypeList
          } else if (res.data.ticketType === 2) {
            this.type = 2
            this.list = res.data.priceMethodSectionVO
            const seateList = []
            this.priceList = res.data.priceMethodSectionVO[0].priceMethodTypeVOList
            res.data.priceMethodSectionVO.forEach((item, index) => {
              const obj = {
                id: index + 1,
                name: item.sectionName
              }
              seateList.push(obj)
            })
            this.seateList = seateList
          }
        })
      }
    }
  }
</script>

<style>
  /* .lineType ::v-deep.el-table .warning-row {
		background: #409EFF;
	} */
  .el-table .warning-row {
    background: oldlace;
  }
</style>
